import React from "react"
import shortid from "shortid"
import css from "@styled-system/css"
import { hideVisually } from "polished"

import { Box, Icon, Text } from "components"

const CustomCheckbox = ({ bg, children, indeterminate, size, ...rest }) => {
  const uid = shortid.generate()

  return (
    <Text
      data-component-id="customCheckbox"
      role="radio"
      as="label"
      //htmlFor={uid}
      size={size}
      position="relative"
      display="block"
      minHeight={[24, 32]}
      pl={[`calc(${24 + "px"} + 12px)`, `calc(${32 + "px"} + 12px)`]}
      css={{ userSelect: "none", cursor: "pointer" }}
    >
      <Box
        data-component-id="customCheckbox.hiddenInput"
        as="input"
        id={uid}
        type="radio"
        ref={el => el && (el.indeterminate = indeterminate)}
        css={css({
          ...hideVisually(),
          "+ div": {
            ".icon": {
              opacity: 0,
            },
          },
          ":checked + div": {
            ".icon": {
              opacity: 1,
            },
          },
        })}
        {...rest}
      />
      <Box
        data-component-id="customCheckbox.control"
        position="absolute"
        top={0}
        left={0}
        display="block"
        width={[24, 32]}
        height={[24, 32]}
        border="4px solid"
        borderColor="text"
        borderRadius={9999}
      >
        <Icon
          className="icon"
          symbol="close"
          size={[24, 32]}
          strokeWidth={2}
          position="absolute"
          top="50%"
          left="50%"
          color="text"
          css={{ transform: "translate(-50%, -50%)" }}
        />
      </Box>
      <Box data-component-id="customCheckbox.text">{children}</Box>
    </Text>
  )
}

CustomCheckbox.defaultProps = {
  bg: "white",
  size: 400,
}

export default CustomCheckbox
